import { PageRef } from 'providers/page-ref';

export type AdminConfigPageParams = {};

export const IAdminConfigPage: PageRef<AdminConfigPageParams, void> = {
  pageName: 'AdminConfigPage',
} as PageRef<AdminConfigPageParams, void>;
